<nav class="navbar navbar-expand-lg navbar-light bg-white topbar mb-4 shadow menu-fixo" *ngIf="!mobileNav">
  <a class="navbar-brand font-weight-bold d-flex align-items-center" [routerLink]="['/main/home']">
    <img [src]="logo ? logo?.logo :  '../../assets/images/logo-hd.png'" height="25"
      class="d-inline-block align-top mr-2" alt="">
  </a>
  <div class="topbar-divider d-sm-block d-none"></div>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarSupportedContent">
    <ul class="navbar-nav ml-1">
      <li class="nav-item dropdown mr-2">
        <a class="nav-link" [routerLink]="['/main/home']" matTooltip="Ocorrências" style="box-shadow: 5px 5px 4px 1px;
        margin-right: 11px; border-radius: 16px;">
          <img src="../../assets/images/icon.ico" alt="ML" style="width: 30px;">
        </a>
      </li>

      <!-- NEW ÁREA-CLÍNICA -->
      <li class="nav-item dropdown"
        *ngIf="verificaAcesso('Implantação') || verificaAcesso('Estatísticas') || verificaAcesso('Escala') || verificaAcesso('Parametrização') || verificaAcesso('Operação')">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuAreaClinica" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Área Clínica
        </a>
        <mat-menu #beforeMenuAreaClinica="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row max-w-col">
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Implantação</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/patients/list']"
                        class="nav-link text-small pb-0 cor2">Cadastro de Paciente</a></li>
                    <li class="nav-item" *ngIf="verificaAcesso('PAD')"><a [routerLink]="['/main/operacao/pad']"
                        class="nav-link text-small pb-0 cor2">Cadastro do PAD</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/budgets/list']"
                        class="nav-link text-small pb-0 cor2">Cadastro de Orçamentos</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/contracts/list']"
                        class="nav-link text-small pb-0 cor2">Ativação de Paciente</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/scales/escalas', 'new']"
                        class="nav-link text-small pb-0 cor2">Cadastro de Escalas</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/medication-transcripts/list']"
                        class="nav-link text-small pb-0 cor2">Transcrições</a></li>
                  </ul>
                </div>
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Estatísticas</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/customer-area/list']"
                        class="nav-link text-small pb-0 cor2">
                        <span class="d-flex align-items-center gap-2">
                          Área do Convênio
                          <app-badge content="NOVO" color="news"></app-badge>
                        </span>
                      </a></li>
                    <li class="nav-item"><a [routerLink]="['/main/clinical-area/dashboard']"
                        class="nav-link text-small pb-0 cor2">
                        <span class="d-flex align-items-center gap-2">
                          Dashboard de Atendimento
                          <!-- <app-badge content="NOVO" color="news"></app-badge> -->
                        </span>
                      </a></li>
                    <li class="nav-item"><a [routerLink]="['/main/cooperative/dashboard']"
                        class="nav-link text-small pb-0 cor2">Dashboard de Cooperativas</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/bidding/dashboard']"
                        class="nav-link text-small pb-0 cor2">Dashboard de Orçamento</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/overview']"
                        class="nav-link text-small pb-0 cor2">Dashboard de Profissionais</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/operacao/management-control']"
                        class="nav-link text-small pb-0 cor2">Timeline do Paciente</a></li>
                  </ul>
                </div>
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">
                    Escala
                  </h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/bore-clearance/list']"
                        class="nav-link text-small pb-0 cor2">Controle de Folgas/Furos</a></li>
                    <li class="nav-item" *ngIf="user.user.pessoa.prestador"><a
                        [routerLink]="['/main/supplier-reports/my-reports/list']"
                        class="nav-link text-small pb-0 cor2">Evolução mensal</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/monitoring']"
                        class="nav-link text-small pb-0 cor2">Monitoramento de escalas</a></li>
                  </ul>
                </div>
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Parametrização</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/operacao/diagnostics-cid-10']"
                        class="nav-link text-small pb-0 cor2">Consulta de diagnósticos médicos (CID-10)</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/cares/list']"
                        class="nav-link text-small pb-0 cor2">Cadastro de Procedimentos</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/care-groups/list']"
                        class="nav-link text-small pb-0 cor2">Cadastro de grupo de procedimentos de enfermagem</a></li>
                  </ul>
                </div>
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">
                    Operação
                  </h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/monitoring/clinical-evolution']"
                        class="nav-link text-small pb-0 cor2">Acompanhamento de Paciente</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/home']"
                        class="nav-link text-small pb-0 cor2">Assistência Farmacêutica</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/documents/list']"
                        class="nav-link text-small pb-0 cor2">Documentos Manuais</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/operacao/ocorrencias-resolvidas']"
                        class="nav-link text-small pb-0 cor2">Ocorrências Resolvidas</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/general-reports/list']"
                        class="nav-link text-small pb-0 cor2">Relatório</a>
                    </li>
                    <li class="nav-item"><a [routerLink]="['/main/area-clinica/operacao/relatorios-personalizados']"
                        class="nav-link text-small pb-0 cor2">Relatórios Personalizados</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>
      <!-- END NEW -->

      <li class="nav-item dropdown" *ngIf="!verificaAcesso('Área Clínica') && user.user.pessoa.prestador">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuAreaClinica" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Área Clínica
        </a>
        <mat-menu #beforeMenuAreaClinica="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-6 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Evolução Clínica</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/supplier-reports/my-reports/list']"
                        class="nav-link text-small pb-0 cor2">Evolução mensal</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>

      <!-- NEW ÁREA ADMINISTRATIVA -->
      <li class="nav-item dropdown"
        *ngIf="verificaAcesso('Financeiro') || verificaAcesso('Medição') || verificaAcesso('Cadastro de Contratos') || verificaAcesso('TI') || verificaAcesso('RH') || verificaAcesso('Agendamento') || verificaAcesso('Diretoria') || verificaAcesso('Faturamento')">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuAreaAdministrativa" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Área Administrativa
        </a>
        <mat-menu #beforeMenuAreaAdministrativa="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('Faturamento') || verificaAcesso('Financeiro')">
                  <ng-template [ngIf]="verificaAcesso('Faturamento')">
                    <h6 class="font-weight-bold text-uppercase cor">
                      Faturamento
                    </h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/billing/dashboard']"
                          class="nav-link text-small pb-0 cor2">Dashboard</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/contracts/list']"
                          class="nav-link text-small pb-0 cor2">Ativação de Paciente</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/budgets/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Orçamentos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/tiss/list']"
                          class="nav-link text-small pb-0 cor2">TISS</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/metering/list']"
                          class="nav-link text-small pb-0 cor2">Medições (Capa de Lote)</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/claim-management/list']"
                          class="nav-link text-small pb-0 cor2">Gestão de Glosas</a></li>
                    </ul>
                  </ng-template>
                  <ng-template [ngIf]="verificaAcesso('Financeiro')">
                    <h6 class="font-weight-bold text-uppercase cor">
                      Financeiro
                    </h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/purchasing-quotations/list']"
                          class="nav-link text-small pb-0 cor2">Cotações de Compras</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/cash-flows/list']"
                          class="nav-link text-small pb-0 cor2">Fluxo de Caixa</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/financial/reports/list']"
                          class="nav-link text-small pb-0 cor2">Relatório Financeiro</a></li>
                    </ul>
                    <p style="
                        font-style: italic;
                        margin: 0;
                        text-decoration: underline;
                      ">
                      Cadastros
                    </p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/categories-natures/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Categoria de Naturezas</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/bank-accounts/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Conta Bancária</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/suppliers/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Fornecedores</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/natures/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Naturezas</a></li>
                    </ul>
                    <p style="
                        font-style: italic;
                        margin: 0;
                        text-decoration: underline;
                      ">
                      Pagamentos
                    </p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/accounts/list-accounts-payable']"
                          class="nav-link text-small pb-0 cor2">Contas
                          a Pagar</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/accounts/list-accounts-receivables']"
                          class="nav-link text-small pb-0 cor2">Contas a Receber</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/cnab-payments/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Pagamentos (CNAB)</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/pix-payments/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Pagamentos (Pix)</a></li>
                    </ul>
                  </ng-template>
                </div>
                <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('Cadastro de Contratos') || verificaAcesso('TI')">
                  <div *ngIf="verificaAcesso('Cadastro de Contratos')">
                    <h6 class="font-weight-bold text-uppercase cor">Cadastro de Contratos</h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/clients/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Operadoras</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/costs/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Custos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/services/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Serviços</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/packages/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Pacotes</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/responsibles/list']"
                          class="nav-link text-small pb-0 cor2">Lista de Responsáveis</a></li>
                    </ul>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/customer-area/list']"
                          class="nav-link text-small pb-0 cor2">Área Convênio</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/taxes/list']"
                          class="nav-link text-small pb-0 cor2 ">Cadastro de Impostos</a></li>
                    </ul>
                  </div>
                  <div *ngIf="verificaAcesso('TI')">
                    <h6 class="font-weight-bold text-uppercase cor">TI</h6>
                    <ul class="list-unstyled">
                      <li class="nav-item">
                        <a [routerLink]="['/main/ti/acessos/cliente']" class="nav-link text-small pb-0 cor2">Acesso de
                          Convênio</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/ti/acessos/profissional']" class="nav-link text-small pb-0 cor2">Acesso
                          de Colaboradores</a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/ti/acessos/responsavel']" class="nav-link text-small pb-0 cor2">Acesso
                          de Responsáveis</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('RH') || verificaAcesso('Diretoria')">
                  <ng-template
                    [ngIf]="user?.user?.pessoa?.profissional?.empresa_id == 2 || verificaAcesso('Diretoria')">
                    <h6 class="font-weight-bold text-uppercase cor">Diretoria</h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/directors/company']"
                          class="nav-link text-small pb-0  cor2">Configurações da Empresa</a>
                      </li>
                      <li class="nav-item"><a [routerLink]="['/main/directors/approve-payments/list']"
                          class="nav-link text-small pb-0 cor2">Lista de Pagamentos</a></li>
                    </ul>
                  </ng-template>
                  <ng-template [ngIf]="verificaAcesso('RH')">
                    <h6 class="font-weight-bold text-uppercase cor">RH / DP</h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/auxiliary-records']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Benefícios, Cargos e Etc</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/external-electronic-points/list']"
                          class="nav-link text-small pb-0 cor2">
                          <span class="d-flex align-items-center gap-2">
                            Ponto Eletrônico
                            <app-badge content="NOVO" color="news"></app-badge>
                          </span>
                        </a></li>
                      <!-- <li class="nav-item">
                        <a [routerLink]="['/main/auditoria/pontos']"
                          class="nav-link text-small pb-0 cor2">
                          <span class="d-flex align-items-center gap-2">
                            Auditoria de Ponto
                            <app-badge
                              content="NOVO"
                              color="news"
                            ></app-badge>
                          </span>
                        </a></li> -->
                      <!-- <li class="nav-item">
                        <a [routerLink]="['/main/auditoria/profissionais']"
                          class="nav-link text-small pb-0 cor2">
                          <span class="d-flex align-items-center gap-2">
                            Controle de Profissionais
                            <app-badge
                              content="NOVO"
                              color="news"
                            ></app-badge>
                          </span>
                        </a></li> -->
                    </ul>
                    <p style="
                        font-style: italic;
                        margin: 0;
                        text-decoration: underline;
                      ">
                      Profissionais
                    </p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/service-providers/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Profissional Externo</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/professionals/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Profissional Interno</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/users/list']"
                          class="nav-link text-small pb-0 cor2">Recrutamento de Profissionais</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/reports-providers/list']"
                          class="nav-link text-small pb-0 cor2">Relatórios de Profissionais Externos</a></li>
                    </ul>
                    <p style="
                        font-style: italic;
                        margin: 0;
                        text-decoration: underline;
                      ">
                      Pagamentos
                    </p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/outer-sheets/list']"
                          class="nav-link text-small pb-0 cor2">Folha
                          Externa</a></li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/outer-sheets/clt/list']" class="nav-link text-small pb-0 cor2">
                          Folha Externa (CLT)
                        </a>
                      </li>
                      <li class="nav-item"><a [routerLink]="['/main/payrolls/internal-payments/list']"
                          class="nav-link text-small pb-0 cor2">Folha
                          Interna</a></li>
                    </ul>
                  </ng-template>
                </div>
                <div class="col-lg-3 mb-4"
                  *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2 || verificaAcesso('Agendamento')">
                  <ng-template [ngIf]="user?.user?.pessoa?.profissional?.empresa_id == 2">
                    <h6 class="font-weight-bold text-uppercase cor">Administrador</h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/companies/list']"
                          class="nav-link text-small pb-0 cor2">Empresas (Clientes)</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/users-access/list']"
                          class="nav-link text-small pb-0  cor2">Usuários</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/notifications/list']"
                          class="nav-link text-small pb-0  cor2">Notificações (Atualizações)</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/ti/dashboard']"
                          class="nav-link text-small pb-0 cor2">Dashboard de Chamados</a></li>
                    </ul>
                  </ng-template>
                  <ng-template [ngIf]="verificaAcesso('Agendamento')">
                    <h6 class="font-weight-bold text-uppercase cor">
                      Agendamentos
                    </h6>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/calendar-room-meeting/list']"
                          class="nav-link text-small pb-0 cor2">Cadastro de Agendamento</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/meeting-rooms/list']"
                          class="nav-link text-small pb-0 cor2">Salas de
                          Reunião</a></li>
                    </ul>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>
      <!-- END NEW -->

      <!-- SUPRIMENTOS -->
      <li class="nav-item dropdown"
        *ngIf="verificaAcesso('Compras') || verificaAcesso('Estoque') || verificaAcesso('Requisição Material')">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuCompras" id="messagesDropdown" role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Suprimentos
        </a>
        <mat-menu #beforeMenuCompras="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-6 mb-4" *ngIf="verificaAcesso('Compras')">
                  <h6 class="font-weight-bold text-uppercase cor">Compras</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/suppliers/list']"
                        class="nav-link text-small pb-0 cor2">Fornecedores</a></li>
                  </ul>

                  <h6 class="font-weight-bold text-uppercase cor">Tabelas de Importação</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a class="nav-link text-small pb-0 cor2"
                        [routerLink]="['/main/tables/brasindice']">Brasindice</a></li>
                    <li class="nav-item"><a class="nav-link text-small pb-0 cor2 "
                        [routerLink]="['/main/tables/simpro']">Simpro</a></li>

                  </ul>
                </div>
                <div class="col-lg-6 mb-4" *ngIf="verificaAcesso('Estoque') || verificaAcesso('Requisição Material') || verificaAcesso('Compras')">
                  <div *ngIf="verificaAcesso('Estoque') || verificaAcesso('Compras')">
                    <h6 class="font-weight-bold text-uppercase cor">Estoque</h6>
                    <ul class="list-unstyled">

                      <!-- NEW INVENTORY -->
                      <li class="nav-item"><a [routerLink]="['/main/products/list']"
                          class="nav-link text-small pb-0 cor2">MAT/MED - Equipamentos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/kit/list']"
                          class="nav-link text-small pb-0 cor2">Kits</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/inventory/products/input/list']"
                          class="nav-link text-small pb-0 cor2">Entrada Nota Fiscal</a></li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/entry-single/list']" class="nav-link text-small pb-0 cor2">
                          Entrada Avulsa
                        </a>
                      </li>
                      <li class="nav-item"><a [routerLink]="['/main/inventory/stock/list']"
                          class="nav-link text-small pb-0 cor2">Relatório Estoque</a></li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/mat-med/stock-control']" class="nav-link text-small pb-0 cor2">
                          Controle de Estoque
                        </a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/output-single/list']" class="nav-link text-small pb-0 cor2">
                          Saída Avulsa
                        </a>
                      </li>
                      <li class="nav-item">
                        <a [routerLink]="['/main/purchase-orders/list']" class="nav-link text-small pb-0 cor2">
                          Solicitação de Compra
                        </a>
                      </li>
                      <!-- END -->
                    </ul>
                  </div>
                  <div *ngIf="verificaAcesso('Requisição Material')">
                    <h6 class="font-weight-bold text-uppercase cor">Requisição Material</h6>
                    <ul class="list-unstyled">
                      <!-- NEW INVENTORY -->
                      <li class="nav-item"><a [routerLink]="['/main/material-requisitions/list']"
                          class="nav-link text-small pb-0 cor2">Requisição de Material</a></li>
                      <!-- END -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>
      <!-- END -->

      <!-- OLD MENUS -->
      <div *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 1">
        <li class="nav-item dropdown" *ngIf="verificaAcesso('Área Clínica')
      || verificaAcesso('Gestão Orçamentária')
      || verificaAcesso('RH')
      || verificaAcesso('Compras')
      || verificaAcesso('Medição')
      || verificaAcesso('Estoque')
      || verificaAcesso('Vendas')
      || verificaAcesso('Requisição Material')">
          <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuAntigo" id="messagesDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Antigos
          </a>
          <mat-menu #beforeMenuAntigo="matMenu" xPosition="before">
            <div class="row bg-white rounded-0 m-0 shadow-sm">
              <div class="p-4">
                <div class="row">
                  <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('Área Clínica')">
                    <h6 class="font-weight-bold text-uppercase cor">Área Clínica</h6>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">Monitoramento</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/operacao/relatorio-folgas']"
                          class="nav-link text-small pb-0 cor2">Controle de Folgas/Furos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/operacao/monitoramento']"
                          class="nav-link text-small pb-0 cor2">Monitoramento</a></li>
                    </ul>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">Cadastros</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/operacao/escalas']"
                          class="nav-link text-small pb-0 cor2">Pacientes/Escalas</a></li>
                    </ul>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">Relatórios</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/operacao/relatorios']"
                          class="nav-link text-small pb-0 cor2">Relatório</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/operacao/documentos']"
                          class="nav-link text-small pb-0 cor2">Documentos Manuais</a></li>
                    </ul>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">PAD</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/operacao/transcricao-medicamentos']"
                          class="nav-link text-small pb-0 cor2">Transcrição de Medicamentos</a></li>
                    </ul>
                  </div>
                  <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('Gestão Orçamentária')">
                    <h6 class="font-weight-bold text-uppercase cor">Gestão Orçamentária</h6>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">Cadastros</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/gestao-orcamentaria/pacotes']"
                          class="nav-link text-small pb-0 cor2">Pacotes</a></li>
                    </ul>
                    <p style="font-style: italic; margin: 0; text-decoration: underline;">Orçamentos</p>
                    <ul class="list-unstyled">
                      <li class="nav-item"><a [routerLink]="['/main/gestao-orcamentaria/contratos']"
                          class="nav-link text-small pb-0 cor2">Contratos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/gestao-orcamentaria/orcamentos']"
                          class="nav-link text-small pb-0 cor2">Orçamentos</a></li>
                      <li class="nav-item"><a [routerLink]="['/main/gestao-orcamentaria/ordem-servicos']"
                          class="nav-link text-small pb-0 cor2">Ordem de Serviço</a></li>
                    </ul>
                  </div>
                  <div class="col-lg-3 mb-4" *ngIf="verificaAcesso('RH') || verificaAcesso('Requisição Material')">
                    <div *ngIf="verificaAcesso('RH')">
                      <h6 class="font-weight-bold text-uppercase cor">RH / DP</h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/rh/ponto-prestador-servico']"
                            class="nav-link text-small pb-0 cor2">Ponto Eletrônico</a></li>
                      </ul>
                      <p style="font-style: italic; margin: 0; text-decoration: underline;">Profissionais</p>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/rh/relatorio-prestador-externo']"
                            class="nav-link text-small pb-0 cor2">Relatório</a></li>
                      </ul>
                      <p style="font-style: italic; margin: 0; text-decoration: underline;">Pagamentos</p>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/rh/pagamentos-externos']"
                            class="nav-link text-small pb-0 cor2">Folha Externa</a></li>
                      </ul>
                    </div>
                    <div *ngIf="verificaAcesso('Requisição Material')">
                      <h6 class="font-weight-bold text-uppercase cor">
                        Requisições
                      </h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/purchase-orders/list']"
                            class="nav-link text-small pb-0 cor2">Pedido de
                            Compra</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/material-requisition/list']"
                            class="nav-link text-small pb-0 cor2">Requisição de Material</a></li>
                      </ul>
                    </div>
                    <div *ngIf="verificaAcesso('Vendas')">
                      <h6 class="font-weight-bold text-uppercase cor">Vendas</h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/clients/list']"
                            class="nav-link text-small pb-0 cor2">Clientes (Tomador)</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/farmacia/vendas']"
                            class="nav-link text-small pb-0 cor2">Venda</a></li>

                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-3 mb-4"
                    *ngIf="verificaAcesso('Medição') || verificaAcesso('Compras') || verificaAcesso('Estoque')">
                    <div *ngIf="verificaAcesso('Medição')" style="margin-bottom: 24px;">
                      <h6 class="font-weight-bold text-uppercase cor">Medição (Capa de Lote)</h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/financeiro/medicoes']"
                            class="nav-link text-small pb-0 cor2">Medições (Capa de Lote)</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/financeiro/lista-tiss']"
                            class="nav-link text-small pb-0 cor2">TISS</a></li>
                      </ul>
                    </div>
                    <div *ngIf="verificaAcesso('Compras')">
                      <h6 class="font-weight-bold text-uppercase cor">Compras</h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/quotations/list']"
                            class="nav-link text-small pb-0 cor2">Cotações</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/leases/list']"
                            class="nav-link text-small pb-0 cor2">Locação</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/compras/mat-med-equipamentos']"
                            class="nav-link text-small pb-0 cor2">MAT/MED - Equipamentos</a></li>
                      </ul>
                    </div>
                    <div *ngIf="verificaAcesso('Estoque')">
                      <h6 class="font-weight-bold text-uppercase cor">Estoque</h6>
                      <ul class="list-unstyled">
                        <li class="nav-item"><a [routerLink]="['/main/stock/entries/list']"
                            class="nav-link text-small pb-0 cor2">Entrada</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/stock/products/list']"
                            class="nav-link text-small pb-0 cor2">Produtos</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/stock/reports/list']"
                            class="nav-link text-small pb-0 cor2">Relatório</a></li>
                        <li class="nav-item"><a [routerLink]="['/main/stock/exits/list']"
                            class="nav-link text-small pb-0 cor2">Saída</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-menu>

        </li>
      </div>
      <!-- END OLD MENUS -->

      <!-- NEW RESPONSAVEL -->
      <li class="nav-item dropdown" *ngIf="verificaAcesso('Responsável') && user.user.pessoa.responsavel">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuResponsavel" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Responsável
        </a>
        <mat-menu #beforeMenuResponsavel="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">
                    Responsável
                  </h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/responsible/signatures/list']"
                        class="nav-link text-small pb-0 cor2">Assinaturas</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/responsible/patients/list']"
                        class="nav-link text-small pb-0 cor2">Meus Pacientes</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/responsible/monitoring']"
                        class="nav-link text-small pb-0 cor2">Monitoramento</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>

      </li>
      <!-- END NEW -->

      <!-- Antigo MENU RESPONSAVEL -->
      <li class="nav-item dropdown" *ngIf="verificaAcesso('Responsável') && user.user.pessoa.responsavel">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuResponsavelOld" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Antigo
        </a>
        <mat-menu #beforeMenuResponsavelOld="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Responsável</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/responsavel/assinaturas']"
                        class="nav-link text-small pb-0 cor2">Assinaturas</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/responsavel/meus-pacientes']"
                        class="nav-link text-small pb-0 cor2">Meus Pacientes</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/responsavel/monitoramento']"
                        class="nav-link text-small pb-0 cor2">Monitoramento</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>
      <!-- END OLD MENU -->

      <!-- NEW CONVÊNIO -->
      <li class="nav-item dropdown" *ngIf="verificaAcesso('Convênio') && user.user.pessoa.cliente">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuConvenio" id="messagesDropdown" role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Convênio (Tomador)
        </a>
        <mat-menu #beforeMenuConvenio="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">
                    Visão Geral
                  </h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/insurence/monitoring/list']"
                        class="nav-link text-small pb-0 cor2">Dashboard</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/insurence/manual-documents/list']"
                        class="nav-link text-small pb-0 cor2 cor2">Documentos Manuais</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/insurence/metering/list']"
                        class="nav-link text-small pb-0 cor2 cor2">Medição (Capa de Lote)</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/insurence/reports/list/new']"
                        class="nav-link text-small pb-0 cor2 cor2">Meus
                        Pacientes</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>

      </li>
      <!-- END NEW -->

      <!-- OLD MENU CONVÊNIO -->
      <li class="nav-item dropdown" *ngIf="verificaAcesso('Convênio') && user.user.pessoa.cliente">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuConvenioOld" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Antigo
        </a>
        <mat-menu #beforeMenuConvenioOld="matMenu" xPosition="before">
          <div class="row bg-white rounded-0 m-0 shadow-sm">
            <div class="p-4">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <h6 class="font-weight-bold text-uppercase cor">Visão Geral</h6>
                  <ul class="list-unstyled">
                    <li class="nav-item"><a [routerLink]="['/main/convenios/dashboard']"
                        class="nav-link text-small pb-0 cor2">Dashboard</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/convenios/documentos-manuais']"
                        class="nav-link text-small pb-0 cor2 cor2">Documentos Manuais</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/convenios/medicoes']"
                        class="nav-link text-small pb-0 cor2 cor2">Medição (Capa de Lote)</a></li>
                    <li class="nav-item"><a [routerLink]="['/main/insurence/reports/list']"
                        class="nav-link text-small pb-0 cor2 cor2">Meus
                        Pacientes</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>
      <!-- END OLD MENU -->
    </ul>
    <ul class="navbar-nav d-flex align-items-center">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/main/chat/chat-geral']" matTooltip="Chat Geral">
          <i class="fas fa-comments" style="font-size: 1.2em"></i>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/main/tutorials']" matTooltip="Treinamentos e Tutoriais">
          <i class="far fa-file-video" style="font-size: 1.2em"></i>
        </a>
      </li>
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuComunicacao" id="messagesDropdown"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" matTooltip="Chamados">
          <i class="fa fa-headset fa-fw" style="font-size: 1.2em"></i>
          <span class="badge badge-danger badge-counter" *ngIf="
              marca_chamado_enfermagem ||
              marca_chamado_ti ||
              marca_chat ||
              marca_chamado
            ">
            *
          </span>
        </a>
        <mat-menu #beforeMenuComunicacao="matMenu" xPosition="before">
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['/main/chat/chamados-enfermagem']">
            <mat-icon>chat</mat-icon>
            <span>Chamados Enfermagem</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['/main/chat/chamados-ti']"
            *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2">
            <mat-icon>chat</mat-icon>
            <span>Chamados TI</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['/main/chat/chamados']">
            <mat-icon>chat</mat-icon>
            <span>Chamados</span>
          </button>
        </mat-menu>
      </li>

      <li class="nav-item dropdown no-arrow" *ngIf="user.user.pessoa.profissional">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenuNotificacao" style="cursor: pointer">
          <i class="fas fa-bell" style="font-size: 1.2em"></i>
          <span class="badge badge-danger badge-counter" *ngIf="totalNotificacoes">
            {{ totalNotificacoes }}
          </span>
        </a>
        <mat-menu #beforeMenuNotificacao="matMenu" xPosition="after" [hasBackdrop]="false">
          <button mat-menu-item (click)="buscarNotificacoes()" (keydown)="$event.stopPropagation()">
            <mat-icon>refresh</mat-icon>
            <span>Refresh</span>
          </button>
          <mat-divider></mat-divider>
          <mat-tab-group (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <mat-tab label="Notificações">
              <mat-list class="custom">
                <!--  -->
                <mat-list-item *ngFor="let notificacao of notificacoes" style="cursor: pointer"
                  [style.background]="notificacao.visto ? '#fff' : '#eee'" (click)="openDialogNotificacao(notificacao)">
                  <mat-icon mat-list-icon>notifications_active </mat-icon>
                  <div mat-line>{{ notificacao?.titulo }}</div>
                  <div mat-line>{{ notificacao?.conteudo }}</div>
                  <div md-line>
                    <mat-icon *ngIf="!notificacao.visto" mat-list-icon style="
                        color: hsl(214deg 89% 51%);
                        font-size: 14px;
                        padding: 0;
                      ">circle
                    </mat-icon>
                  </div>
                </mat-list-item>
              </mat-list>
            </mat-tab>
            <mat-tab label="Alertas">
              <mat-list class="custom">
                <!--  -->
                <mat-list-item *ngFor="let aviso of avisos" style="cursor: pointer"
                  [style.background]="aviso.visto ? '#fff' : '#eee'" (click)="openDialogNotificacao(aviso)">
                  <mat-icon mat-list-icon>warning</mat-icon>
                  <div mat-line>{{ aviso?.titulo }}</div>
                  <div mat-line>{{ aviso?.conteudo }}</div>
                  <div md-line>
                    <mat-icon *ngIf="!aviso.visto" mat-list-icon style="
                        color: hsl(214deg 89% 51%);
                        font-size: 14px;
                        padding: 0;
                      ">circle</mat-icon>
                  </div>
                </mat-list-item>
              </mat-list>
            </mat-tab>
          </mat-tab-group>
        </mat-menu>
      </li>
      <li style="padding-right: 0.5rem; padding-left: 0.5rem" *ngIf="user.user.pessoa.profissional">
        <button class="btnSearch btn" (click)="searchSetState('minhaDiv')" style="border: 0; padding: 0">
          <i class="fas fa-search" style="color: #49a28f; font-size: 1.2rem"></i>
        </button>
      </li>
      <div class="topbar-divider d-sm-block d-none"></div>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="beforeMenu" id="userDropdown" role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img class="img-profile rounded-circle" [src]="
              user?.user?.pessoa.perfil
                ? user?.user?.pessoa.perfil
                : '../../assets/images/user.png'
            " />
          <span class="ml-2 d-lg-inline">{{
            primeiroNome(user?.user?.pessoa?.nome) | titlecase
            }}</span>
        </a>
        <mat-menu #beforeMenu="matMenu" xPosition="before">
          <div class="profile-card">
            <div class="header p-4">
              <img [src]="
                  user?.user?.pessoa.perfil
                    ? user?.user?.pessoa.perfil
                    : '../../assets/images/user.png'
                " alt="Foto" style="display: block; margin: 0 auto" />
            </div>
            <h5 style="margin-top: 0">{{ user?.user?.pessoa?.nome }}</h5>
            <p class="small">{{ user?.user?.email }}</p>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['/main/my-profile']">
            <mat-icon>account_circle</mat-icon>
            <span>Minha Conta</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span> Sair</span>
          </button>
          <mat-divider></mat-divider>
          <footer>
            <img src=" ../../assets/images/icon.ico" alt="ML" style="width: 32px" />
            <p>&copy; Todos os direitos reservados.</p>
          </footer>
        </mat-menu>
      </li>
    </ul>
  </div>
  <div class="row" style="padding-left: 15px; margin-right: 15px; position: absolute; top: 62px; z-index: 999; right:0"
    [formGroup]="form">
    <div id="minhaDiv" style="width: 30vw; display: none">
      <div>
        <mat-form-field appearance="fill" style="display: block;">
          <input matInput placeholder="O que você procura?" [matAutocomplete]="auto" formControlName="filter" />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-optgroup *ngFor="let cat of filteredOptions | async" label="{{ cat.module }}" class="optionsGroup">
              <mat-option *ngFor="let tipo of cat.components" (click)="navigateTo(tipo.value)" class="options">
                {{ tipo.label }}
                <span style="
                    font-size: 11px;
                    display: flex;
                    margin-top: -30px;
                  ">{{ tipo.path }}</span>
              </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>
</nav>


<app-nav-mobile *ngIf="mobileNav"></app-nav-mobile>

<div class="col-lg-12" style="top: 100px">
  <router-outlet></router-outlet>
</div>
